import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/progress-spinner/progress-spinner.component.ts